import React, { useEffect, useRef } from 'react'
import {
  Grid,
  Container,
  Avatar,
  Card,
  CardHeader,
  CardContent,
  useTheme,
  Divider,
  Tooltip,
  IconButton
} from '@mui/material'

import customTheme from '../../../material-ui/theme'

import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness'
import EditIcon from '@mui/icons-material/Edit'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import DeleteIcon from '@mui/icons-material/Delete'

import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import moment from 'moment'
import Swal from 'sweetalert2'

import { CustomTitle } from '../../common/CustomTitle/CustomTitle'
import { CustomTable } from '../../common/Tables/CustomTable/CustomTable'
import { DynamicProfileDetails } from './DynamicProfileDetails/DynamicProfileDetails'

import {
  startPanelsDynamicProfilesLoad,
  startPanelsDynamicProfilesActive,
  startPanelsDynamicProfilesDelete
} from '../../../reducers/dynamicLighting/panelsDynamicProfilesActions'

export const DynamicProfileScreen = () => {
  const isLoaded = useRef(false)
  console.log('DynamicProfileScreen rendered')
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { profiles, active } = useSelector(state => state.panelsDynamicProfiles)

  const columns = [
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Nombre' },
    { id: 'date', label: 'Fecha' }
  ]

  const redirect = url => {
    navigate(url)
  }

  const handleProfileClick = id => {
    dispatch(startPanelsDynamicProfilesActive(id))
  }

  const handleDeleteProfile = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se eliminará el perfil {{name}}',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ffc90e',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then(res => {
      if (res.isConfirmed) {
        dispatch(startPanelsDynamicProfilesDelete())
      }
    })
  }

  useEffect(() => {
    dispatch(startPanelsDynamicProfilesLoad())
  }, [dispatch])

  useEffect(() => {
    if (isLoaded.current === false) {
      if (active && active.id) {
        dispatch(startPanelsDynamicProfilesActive(active.id))
      }

      isLoaded.current = true
    }
  }, [dispatch, active])

  return (
    <Container
      maxWidth={false}
      sx={{
        p: 2
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CustomTitle
            title={'Perfiles dinámicos'}
            icon={
              <Avatar>
                <SettingsBrightnessIcon />
              </Avatar>
            }
          />
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardHeader
              title={`${'Perfiles de iluminación dinámica'} ~ ${'Centros de mando'}`}
              avatar={
                <Avatar
                  src={customTheme.devicesIcons.panel.avatar}
                  sx={{
                    borderRadius: 0
                  }}
                />
              }
              action={
                <>
                  {active && (
                    <>
                      <Tooltip title={'Eliminar perfil'} aria-label='delete'>
                        <IconButton onClick={handleDeleteProfile}>
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={'Editar perfil'} aria-label='edit'>
                        <IconButton
                          onClick={() => {
                            redirect('/dynamic-lighting/profiles/panels/update')
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}

                  <Tooltip title={'Crear nuevo perfil'} aria-label='add'>
                    <IconButton
                      onClick={() => {
                        redirect('/dynamic-lighting/profiles/panels')
                      }}
                    >
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>
                </>
              }
            />

            {active && (
              <>
                <Divider />

                <DynamicProfileDetails profile={active} />

                <Divider />
              </>
            )}

            <CardContent
              sx={{
                cursor: 'pointer'
              }}
            >
              <CustomTable
                rows={profiles.map(profile => ({
                  ...profile,
                  date: profile.date
                    ? moment(profile.date).format('DD MMM yyyy HH:mm')
                    : '',
                  _onClick: handleProfileClick
                }))}
                columns={columns}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  )
}